export default __webpack_public_path__ + "0914cb0b5bae19ffb57c2a9164f2aed3.woff2";